





























































import { Component, Watch } from 'vue-property-decorator'
import Alert from '@/components/Shared/Alert.vue';
import { AppModule } from '@/store/Auth/AppModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import zxcvbn from 'zxcvbn';
import PageNames from '@/router/PageNames';
import ResetPasswordRequest from '@/models/Settings/Users/ResetPasswordRequest';
import SaascadaVueForm from '@/components/Shared/SaascadaVueForm';

@Component({ name: 'ResetPassword', components: { Alert }, metaInfo: { title: 'Reset Password' } })
export default class extends SaascadaVueForm {

    email: string = '';
    resetToken: any = '';
    password: string = '';
    verifyPassword: string = '';
    score: number = 0;
    hint: string = '';
    valid: boolean = false;
    match: boolean = true; // match is true by default because initially both password fields are empty

    async beforeMount() {
        this.email = '';
        this.resetToken = this.$route.query.resetToken;
    }

    async reset() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }

        const request = new ResetPasswordRequest();
        request.email = this.email;
        request.newPassword = this.password;
        request.passwordResetToken = this.resetToken

        await AuthModule.resetPassword(request);
    }

    get isErrorVisible() {
        return AppModule.lastErrorVisible;
    }

    get submitDisabled() {
        if (!this.match) {
            return true;
        }
        if (!this.valid) {
            return true;
        }
        return false;
    }

    get loadingResetPassword() {
        return AuthModule.loadingResetPassword;
    }

    get resetPasswordSuccess() {
        return AuthModule.resetPasswordSuccess;
    }

    @Watch("loadingResetPassword")
    async loadingResetPasswordChanged(value: boolean, previousVaule: boolean) {
        // If the value of loadingResetPassword went from true to false then loading just finished
        // so check the value of resetPasswordSuccess to see if we should redirect the page
        if (previousVaule && !value && this.resetPasswordSuccess) {
            this.$router.push({ name: PageNames.Login });
        }
    }

    @Watch("password")
    async passwordChanged(val: string, oldVal: string) {
        // If the password and the verifyPassword are not empty, check if they match
        if (val !== "" && this.verifyPassword !== "") {
            this.match = (val === this.verifyPassword);
        }
        // If the password is empty then reset the score
        if (val === "") {
            this.score = 0;
            this.valid = false;
        }

        // Check the password to get a score and show a hint or set if valid
        const passwordResult = zxcvbn(this.password);
        this.score = passwordResult.score;

        if (passwordResult.feedback.suggestions.length !== 0) {
            // Note: The hint is not currently connected to translations and i18n
            this.hint = "Hint: " + passwordResult.feedback.suggestions[0];
        }
        else {
            this.hint = "";
        }

        if (this.score >= 3) {
            this.valid = true;
        }
        else {
            this.valid = false;
        }
    }

    @Watch("verifyPassword")
    async verifyPasswordChanged(val: string, oldVal: string) {
        this.match = (val === this.password);
    }

}
